import { useMutation, useQueryClient } from "@tanstack/react-query";

import { type MessageAgentReplyFeedbackVote } from "@fitness-app/data-models/entities/Chat";

import {
  pendingChatAgentSuggestionsQueryKey,
  pendingChatSuggestionChannelsQueryKey,
} from "~/modules/Chat/hooks/chatAgentSuggestionQueryKeys";
import { chatApi } from "~/store/initializeStore";

export type ChatAgentSuggestionAction = "accept" | "dismiss" | "regenerate" | "feedback";
export type ChatAgentSuggestionActionPayload = {
  messageId: string;
  replyText?: string;
  feedbackVote?: MessageAgentReplyFeedbackVote;
  feedbackComment?: string;
};

export const useChatAgentSuggestionAction = (action: ChatAgentSuggestionAction) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: ChatAgentSuggestionActionPayload) => {
      const { data } = await chatApi.post<object>(`/chat-agent-suggestion/${action}`, payload);

      return data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: pendingChatSuggestionChannelsQueryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: pendingChatAgentSuggestionsQueryKey,
        }),
      ]);
    },
  });
};
